var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.74,
    height: 24.391,
    viewBox: "0 11.779 24.74 24.391"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "shopping-cart"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.502 34.12a2 2 0 110 .1z",
    fill: "#4a4a4a",
    fillRule: "evenodd",
    "data-name": "Ellipse 15"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.923 34.12a2 2 0 110 .1z",
    fill: "#4a4a4a",
    fillRule: "evenodd",
    "data-name": "Ellipse 16"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Pfad 1733"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 17.19l-.33-2.58a3.178 3.178 0 00-3.14-2.83H0v2.45h1.83c.4 0 .71.3.75.69l1.6 12.71a3.178 3.178 0 003.14 2.83h13.81l3.61-13.27H5.3zm13.99 10.83H7.32a.759.759 0 01-.74-.7l-.97-7.68h15.96l-2.28 8.38z",
    fill: "#4a4a4a",
    fillRule: "evenodd",
    "data-name": "Pfad 1734"
  })))));
}
export default __webpack_public_path__ + "static/media/Shopping_Cart.7f0bef87.svg";
export { SvgShoppingCart as ReactComponent };